<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <div class="hs-screen-row">
                <Input v-model="params.fullName" placeholder="省市区名称" clearable style="width: 200px"/>
            </div>
            <div class="hs-screen-row">
                <Select v-model="params.isOpen" placeholder="开通状态" clearable style="width:200px">
                    <Option value="">全部</Option>
                    <Option value="0">未开通</Option>
                    <Option value="1">已开通</Option>
                </Select>
            </div>
            <div class="hs-screen-row">
                <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                            separator=" ~ " split-panels transfer
                            placeholder="创建时间" style="width: 200px"></DatePicker>
            </div>
            <div class="hs-screen-row">
                <Button type="primary" @click="search">查询</Button>
            </div>
            <div class="hs-screen-row">
                <Button @click="resetScreen">重置</Button>
            </div>
        </Card>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--标题-->
            <div slot="title">
                <div class="hs-screen-box">
                    <div>开通地区列表</div>
                    <div>
                        <ButtonGroup>
                            <Button @click="findOpenCityList">
                                <Icon type="md-refresh" size="15"/>
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            <!--表格数据-->
            <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

                <template slot-scope="{ row, index }" slot="isOpen">
                    <Tag color="volcano" v-if="row.isOpen == 0" size="default">未开通</Tag>
                    <Tag color="green" v-if="row.isOpen == 1" size="default">已开通</Tag>
                </template>

                <template slot-scope="{ row, index }" slot="createTime">
                    <span v-if="row.createTime">{{row.createTime}}</span>
                    <span v-if="!row.createTime">-</span>
                </template>

                <template slot-scope="{ row }" slot="action">
                  <Button type="primary" size="small" style="margin-right: 5px" v-if="row.isOpen == 0" @click="isOpenCity(row)">开通</Button>
                  <Button type="error" size="small" style="margin-right: 5px" v-if="row.isOpen == 1" @click="isOpenCity(row)">关闭</Button>
                  <Button type="success" size="small" style="margin-right: 10px" @click="toRangeMap(row)">设置范围</Button>
                </template>

            </Table>
            <!--分页-->
            <div class="hs-page">
                <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                      @on-page-size-change="changePageSize"/>
            </div>
        </Card>
        
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';

    export default {
        name: "admin",
        data() {
            return {
                total: 0,
                dateInit: '',
                isTableLoading: false,
                // 参数
                params: {
                    page: 1,
                    rows: 10,
                    isOpen: '',
                    fullName: '',
                    openStartTime: '',
                    openEndTime: ''
                },
                // 表格列
                columns: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        minWidth: 120,
                        key: 'openCityId'
                    },
                    {
                        title: '地区/区县',
                        minWidth: 120,
                        key: 'localName'
                    },
                    {
                        title: '地区全称',
                        minWidth: 120,
                        key: 'fullName'
                    },
                    {
                        title: '状态',
                        slot: 'isOpen',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 250,
                        align: 'center'
                    }
                ],
                // 表格数据
                data: [],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: '系统管理', url: '', icon: '', size: 0},
                    {name: '开通地区列表', url: '', icon: '', size: 0}
                ]
            }
        },
        created() {
            // 开通地区-列表查询
            this.findOpenCityList();
        },
        methods: {
            // 开通地区-列表查询
            findOpenCityList() {
                this.isTableLoading = true;
                this.axios.post('/openCity/findOpenCityList', this.params).then(res => {
                    console.log(res);
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.total = res.data.total;
                        this.data = res.data.rows;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查询开通地区列表接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 是否禁用开通地区
            isOpenCity(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否${row.isOpen ? '关闭' : '开通'}当前地区？`,
                    onOk: () => {
                        this.switchOpenCity(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 开通/关闭地区
            switchOpenCity(row) {
                let cityArray = [{
                    regionId: row.regionId,
                    isOpen: row.isOpen ? 0 : 1
                }];
                this.$Spin.show();
                this.axios.post('/openCity/switchOpenCity', {
                    cityArray: cityArray
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findOpenCityList();
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '禁用开通地区接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 日期条件赋值
            changeDate(e) {
                this.params.openStartTime = e[0];
                this.params.openEndTime = e[1];
            },
            // 重置筛选条件
            resetScreen() {
                this.params.isOpen = '';
                this.params.fullName = '';
                this.params.openStartTime = '';
                this.params.openEndTime = '';
                this.dateInit = '';
            },
            search() {
                this.params.page = 1
                this.findOpenCityList();
            },
            // 改变页数
            changePage(e) {
                this.params.page = e;
                this.findOpenCityList();
            },
            // 改变页容量
            changePageSize(e) {
                this.params.rows = e;
                this.findOpenCityList();
            },
          toRangeMap(row) {
            this.$router.push({path: '/index/open-range-map',query:{
                regionId: row.regionId,
                pointsArr: row.mapRange,
              }})
          },
        },
        components: {
            hsBreadcrumb
        }
    }
</script>

<style scoped>

</style>